module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero6.png?ce2ae9af";